import {
  BooleanForm as BooleanFormQnr,
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import { useSafeTranslation } from 'shared/i18n';

export const BooleanForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  ...rest
}: QuestionnaireFormProps<Questionnaire>) => {
  const { t } = useSafeTranslation();

  return (
    <BooleanFormQnr
      {...rest}
      value={value as boolean | undefined}
      trueLabel={t('generic.qnr.booleanForm.trueLabel', 'Yes')}
      falseLabel={t('generic.qnr.booleanForm.falseLabel', 'No')}
    />
  );
};
